export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 200

interface PasswordValidationOptions {
  required?: boolean
}

export function validatePasswordComplexity(
  password: string | null | undefined,
  { required = true }: PasswordValidationOptions = {}
): string | null {
  const normalizedPassword = password ?? ''

  if (!normalizedPassword) {
    return required ? 'Пароль обязателен.' : null
  }

  if (normalizedPassword.length < PASSWORD_MIN_LENGTH) {
    return `Пароль должен содержать не менее ${PASSWORD_MIN_LENGTH} символов.`
  }

  if (normalizedPassword.length > PASSWORD_MAX_LENGTH) {
    return `Пароль не должен превышать ${PASSWORD_MAX_LENGTH} символов.`
  }

  if (!/[a-zA-Zа-яА-ЯёЁ]/.test(normalizedPassword)) {
    return 'Пароль должен содержать хотя бы одну букву.'
  }

  if (!/\d/.test(normalizedPassword)) {
    return 'Пароль должен содержать хотя бы одну цифру.'
  }

  return null
}

export function getPasswordComplexityHint(): string {
  return `Минимум ${PASSWORD_MIN_LENGTH} символов, хотя бы одна буква и одна цифра.`
}
